import { useEffect } from 'react';
import { useQueryParam } from 'use-query-params';

export function useQueryParamWithDefault(name, paramConfig, defaultValue, cId, flags = { clearOnUnmount: true }, options, updateType) {
    const [value, setValue] = useQueryParam(cId ? `${cId}_${name}` : name, paramConfig, options, updateType);

    useEffect(() => {
        if (value === undefined && defaultValue !== undefined) {
            setValue(defaultValue);
        }

        return () => {
            if (flags.clearOnUnmount) {
                setValue(null);
            }
        };
    }, []);

    return [value, setValue];
}
